import { createContext, useContext } from "react"

const Context = createContext()
export const Provider = Context.Provider
export function useSuspender(...args) {
  return (useContext(Context)?.handler ?? Function.prototype)(...args)
}
export function useSuspenderStore() {
  return useContext(Context)?.store ?? new Map()
}
